import React, { useCallback } from 'react';
import { compose, omit } from 'ramda';
import { defaultProps, mapProps } from 'recompose';
import { withTranslations } from 'js/components/hocs/withTranslations';
import { Button } from 'js/components/common/Button';
import withGameLaunch from 'js/components/common/Game/withGameLaunch';
import style from './index.scss';

export const tKeyPrefix = 'playtech.mobile.system.button';

export const PlayButton = compose(
    defaultProps({
        mode: 1,
        className: '',
        tKey: `${tKeyPrefix}.realPlay`
    }),
    withTranslations,
    withGameLaunch,
    mapProps(omit(['code']))
)(({
    launchGame,
    gameLaunchType,
    name: gameName,
    mode,
    tKey,
    t,
    className = '',
    isHoverBtn,
    queryString,
    onGameLaunched,
    // for game launch event tracking
    container,
    gameFeed,
    tidPgg,
    categoryName,
    pggCategoryName,
    categoryPosition,
    gamePositionInCategory,
    ...others
}) => {
    const onClick = useCallback(() => {
        launchGame({
            container,
            gameFeed,
            gameName,
            queryString,
            onGameLaunched,
            gameLaunchType,
            launchType: mode ? 'Real' : 'Demo',
            tidPgg,
            categoryName,
            pggCategoryName,
            categoryPosition,
            gamePositionInCategory
        });
    }, [
        launchGame, container, gameFeed, gameName, queryString, onGameLaunched, gameLaunchType, mode,
        tidPgg, categoryName, categoryPosition, gamePositionInCategory, pggCategoryName
    ]);

    return (
        <Button
            onClick={onClick}
            className={`${className} ${style.button} ${isHoverBtn ? style[mode ? 'play' : 'demo'] : ''}`}
            {...others}>
            {t(tKey)}
        </Button>
    );
});

export const DemoButton = props =>
    <PlayButton
        mode={0}
        tKey={`${tKeyPrefix}.demoPlay`}
        view="secondary"
        color="info"
        {...props}
    />;
